import { Collapse, Tooltip } from "antd";
import React from "react";

import CommonFilterTable from "../../../component/table/TableFiltter";
import { CONFIG, lang, MODE_SCREEN } from "../../../constants/common.const";
import "./facilityMaster.scss";

const ListFacilityMaster = ({
  currentNode,
  setCurrentNode,
  listData: dataSource,
  setFirstNodeFilter,
  mode,
  idFocus
}) => {
  const renderText = (text) => (
    <Tooltip title={text}>
      <span>{text && String(text).substring(0,25)}</span>
    </Tooltip>
  );

  const columns = [
    {
      title: lang.FACILITY_ID,
      dataIndex: "facilityCode",
      width: 150,
      align: "left",
      render:(text) => renderText(text)
    },
    {
      title: lang.FACILITY_MASTER_NAME,
      dataIndex: "facilityName",
      width: 200,
      align: "left",
      render:(text) => renderText(text)
    },
    {
      title: lang.AREA_NAME_FACILITY,
      dataIndex: "areaName",
      width: 200,
      align: "left",
      render:(text) => renderText(text)
    },
    {
      title: lang.MODEL_CODE,
      dataIndex: "plantName",
      width: 150,
      align: "center",
      render:(text) => renderText(text)
    },
    {
      title: lang.FACILITY_NUMBER,
      dataIndex: "facilityNumber",
      width: 200,
      align: "center",
      type: "number",
      render:(text) => renderText(text)
    },
    {
      title: lang.DISPLAY_ORDER,
      dataIndex: "displayOrder",
      width: 150,
      align: "center",
      type: "number",
      render:(text) => renderText(text)
    },
  ];

  return (
    <div>
      <CommonFilterTable
        setFirstNodeFilter={setFirstNodeFilter}
        rowClassName={(record) =>
          currentNode && record.facilityCode === currentNode.facilityCode
            ? "selected-row-facilityMaster"
            : ""
        }
        onRow={(record) => ({
          onClick: () => setCurrentNode(record),
        })}
        rowKey="facilityCode"
        pagination={{ ...CONFIG.paging, pageSize: 10 }}
        data={dataSource}
        columns={columns}
        className="table-selected-custom table-equipment-custome my-custom-table mt10"
        scrollY={"calc(100vh - 280px)"}
        paging={true}
        tableKey="facility"
        addedLeft={160}
        disabledFilter={mode !== MODE_SCREEN.VIEW}
        idFocus={idFocus}
      />
    </div>
  );
};

export default React.memo(ListFacilityMaster);
